var formDialogService = angular.module('eficienciaFiscalModule');

formDialogService.service('formDialogService', ['$timeout', 'dialogService', 'httpService', 'pathService', function ($timeout, dialogService, httpService, pathService) {
    this.initFormDialog = function (scope, options) {
        if (options.data_holder != undefined)
            eval("scope." + options.data_holder + " = options.data;");

        options.divId = new Date().valueOf();

        var div = "<div style='display: none' id='" + options.divId + "'></div>"

        if (options.holder == null)
            $('body').append(div);
        else
            $(options.holder).append(div);

        $('#' + options.divId).html('');

        if (options.loadContentOptions == undefined)
            options.loadContentOptions = {};

        options.loadContentOptions.onPostExecute = function () {
            dialogService.initDialog(scope, options);
        }

        options.loadContentOptions.compileAfter = false;

        var htmlPath = options.partial ? pathService.getViewUrl() + options.partial : options.url;

//        $('#' + options.divId).load('/app/module' + options.partial, function() {
//            dialogService.initDialog(scope, options);
//        })

        httpService.loadContent(scope, '#' + options.divId, htmlPath, options.loadContentOptions);

    };
}]);
